<template>
    <div>
        <h6 v-if="screenWidth < 992" class="filter-mobile-title">
            <span>
                {{ result.messages.catalog }}
            </span>
        </h6>
        <catalog-aside-menu
            v-if="options && options.showAsideMenu && !showShortFilter"
        />
        <CancelFilterInline
            v-if="showShortFilter"
            :result="result"
            @handlerChangeData="$emit('changeFilter')"
            @resetFilter="$emit('resetFilter', $event)"
        />
        <div class="catalog-filter" v-show="!showShortFilter">
            <form
                ref="filter-form"
                class="catalog-filter__color filter"
                id="filter"
            >
                <input v-for="item in result.hidden" :name="item.name" :value="item.value" type="hidden">
                <CancelFilter
                    :result="result" @handlerChangeData="$emit('changeFilter')"
                    @resetFilter="$emit('resetFilter', $event)"
                />

                <div v-for="item in result.ITEMS">
                    <div v-if="item.DISPLAY_TYPE === 'A'">
                        <h6 class="catalog-filter__title">{{ item.NAME }}</h6>
                        <div class="filter-range">
                            <input
                                class="filter-range__input"
                                type="number"
                                :id="item.VALUES.MIN.CONTROL_ID"
                                :name="item.VALUES.MIN.CONTROL_NAME"
                                :value="item.VALUES.MIN.HTML_VALUE"
                                :placeholder="item.VALUES.MIN.VALUE"
                            >
                            <input
                                class="filter-range__input"
                                type="number"
                                :id="item.VALUES.MIN.CONTROL_ID"
                                :name="item.VALUES.MAX.CONTROL_NAME"
                                :value="item.VALUES.MAX.HTML_VALUE"
                                :placeholder="item.VALUES.MAX.VALUE"
                            >
                            <span
                                class="filter-range__button"
                                @click="$emit('changeFilter')"
                            >
                                ОК
                            </span>
                        </div>
                        <hr class="catalog-filter__line">
                    </div>
                    <div v-else>
                        <FilterBlock
                            v-if="item.CODE !== 'BASE'"
                            :result="item"
                        />
                    </div>
                </div>
              <div class="catalog-filter__buttons_wrapper">
                <button
                    v-if="result.messages.accept"
                    @click="$emit('changeFilter')"
                    type="button"
                    class="def-button catalog-filter__button"
                >
                    {{ result.messages.accept }}
                </button>
                <button
                    @click.prevent="$emit('resetFilter', result.actions.resetFilter.href)"
                    type="reset"
                    class="def-button catalog-filter__button"
                >
                    {{result.actions.resetFilter.text}}
                </button>
              </div>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CatalogFilter',
    props: {
        result: {
            type: Object,
            default: () => ({
                "form": {"name": null, "action": "/catalog/test/", "method": "get"},
                "hidden": [{"name": "ajax", "value": "y"}],
                "ITEMS": {
                    "183": {
                        "ID": "183",
                        "IBLOCK_ID": "24",
                        "CODE": "MINIMUM_PRICE",
                        "~NAME": "Минимальная цена",
                        "NAME": "Минимальная цена",
                        "PROPERTY_TYPE": "N",
                        "USER_TYPE": null,
                        "USER_TYPE_SETTINGS": null,
                        "DISPLAY_TYPE": "A",
                        "DISPLAY_EXPANDED": "Y",
                        "FILTER_HINT": "",
                        "VALUES": {
                            "MIN": {
                                "CONTROL_ID": "arCatalogFilter_183_MIN",
                                "CONTROL_NAME": "arCatalogFilter_183_MIN",
                                "VALUE": "52478"
                            },
                            "MAX": {
                                "CONTROL_ID": "arCatalogFilter_183_MAX",
                                "CONTROL_NAME": "arCatalogFilter_183_MAX",
                                "VALUE": "75252"
                            }
                        }
                    },
                    "184": {
                        "ID": "184",
                        "IBLOCK_ID": "24",
                        "CODE": "METALL",
                        "~NAME": "Металл",
                        "NAME": "Металл",
                        "PROPERTY_TYPE": "S",
                        "USER_TYPE": "directory",
                        "USER_TYPE_SETTINGS": {
                            "size": 1,
                            "width": 0,
                            "group": "N",
                            "multiple": "N",
                            "TABLE_NAME": "a_metals"
                        },
                        "DISPLAY_TYPE": "F",
                        "DISPLAY_EXPANDED": "N",
                        "FILTER_HINT": "",
                        "VALUES": {
                            "zoloto": {
                                "CONTROL_ID": "arCatalogFilter_184_2755422981",
                                "CONTROL_NAME": "arCatalogFilter_184_2755422981",
                                "CONTROL_NAME_ALT": "arCatalogFilter_184",
                                "HTML_VALUE_ALT": 2755422981,
                                "HTML_VALUE": "Y",
                                "VALUE": "zoloto",
                                "SORT": 0,
                                "UPPER": "ZOLOTO",
                                "FLAG": null,
                                "URL_ID": "zoloto"
                            }
                        }
                    },
                    "186": {
                        "ID": "186",
                        "IBLOCK_ID": "24",
                        "CODE": "COLOR_METALL",
                        "~NAME": "Цвет металла",
                        "NAME": "Цвет металла",
                        "PROPERTY_TYPE": "S",
                        "USER_TYPE": "directory",
                        "USER_TYPE_SETTINGS": {
                            "size": 1,
                            "width": 0,
                            "group": "N",
                            "multiple": "N",
                            "TABLE_NAME": "a_colors"
                        },
                        "DISPLAY_TYPE": "F",
                        "DISPLAY_EXPANDED": "N",
                        "FILTER_HINT": "",
                        "VALUES": {
                            "biliy": {
                                "CONTROL_ID": "arCatalogFilter_186_3218423947",
                                "CONTROL_NAME": "arCatalogFilter_186_3218423947",
                                "CONTROL_NAME_ALT": "arCatalogFilter_186",
                                "HTML_VALUE_ALT": 3218423947,
                                "HTML_VALUE": "Y",
                                "VALUE": "biliy",
                                "SORT": 0,
                                "UPPER": "BILIY",
                                "FLAG": null,
                                "URL_ID": "biliy"
                            },
                            "chervoniy": {
                                "CONTROL_ID": "arCatalogFilter_186_3589656623",
                                "CONTROL_NAME": "arCatalogFilter_186_3589656623",
                                "CONTROL_NAME_ALT": "arCatalogFilter_186",
                                "HTML_VALUE_ALT": 3589656623,
                                "HTML_VALUE": "Y",
                                "VALUE": "chervoniy",
                                "SORT": 0,
                                "UPPER": "CHERVONIY",
                                "FLAG": null,
                                "URL_ID": "chervoniy"
                            }
                        }
                    },
                    "187": {
                        "ID": "187",
                        "IBLOCK_ID": "24",
                        "CODE": "PROBA",
                        "~NAME": "Проба",
                        "NAME": "Проба",
                        "PROPERTY_TYPE": "S",
                        "USER_TYPE": "directory",
                        "USER_TYPE_SETTINGS": {
                            "size": 1,
                            "width": 0,
                            "group": "N",
                            "multiple": "N",
                            "TABLE_NAME": "a_proba"
                        },
                        "DISPLAY_TYPE": "F",
                        "DISPLAY_EXPANDED": "N",
                        "FILTER_HINT": "",
                        "VALUES": {
                            "585": {
                                "CONTROL_ID": "arCatalogFilter_187_2630715057",
                                "CONTROL_NAME": "arCatalogFilter_187_2630715057",
                                "CONTROL_NAME_ALT": "arCatalogFilter_187",
                                "HTML_VALUE_ALT": 2630715057,
                                "HTML_VALUE": "Y",
                                "VALUE": "585",
                                "SORT": 100,
                                "UPPER": "585",
                                "FLAG": null,
                                "URL_ID": "585"
                            }
                        }
                    },
                    "188": {
                        "ID": "188",
                        "IBLOCK_ID": "24",
                        "CODE": "VSTAVKI",
                        "~NAME": "Вставка",
                        "NAME": "Вставка",
                        "PROPERTY_TYPE": "S",
                        "USER_TYPE": "directory",
                        "USER_TYPE_SETTINGS": {
                            "size": 1,
                            "width": 0,
                            "group": "N",
                            "multiple": "N",
                            "TABLE_NAME": "a_vstavki"
                        },
                        "DISPLAY_TYPE": "F",
                        "DISPLAY_EXPANDED": "N",
                        "FILTER_HINT": "",
                        "VALUES": {
                            "diamant": {
                                "CONTROL_ID": "arCatalogFilter_188_1165216290",
                                "CONTROL_NAME": "arCatalogFilter_188_1165216290",
                                "CONTROL_NAME_ALT": "arCatalogFilter_188",
                                "HTML_VALUE_ALT": 1165216290,
                                "HTML_VALUE": "Y",
                                "VALUE": "diamant",
                                "SORT": 0,
                                "UPPER": "DIAMANT",
                                "FLAG": null,
                                "URL_ID": "diamant"
                            },
                            "perli_kultivovani": {
                                "CONTROL_ID": "arCatalogFilter_188_3230038819",
                                "CONTROL_NAME": "arCatalogFilter_188_3230038819",
                                "CONTROL_NAME_ALT": "arCatalogFilter_188",
                                "HTML_VALUE_ALT": 3230038819,
                                "HTML_VALUE": "Y",
                                "VALUE": "perli_kultivovani",
                                "SORT": 0,
                                "UPPER": "PERLI_KULTIVOVANI",
                                "FLAG": null,
                                "URL_ID": "perli_kultivovani"
                            },
                            "topaz": {
                                "CONTROL_ID": "arCatalogFilter_188_838008019",
                                "CONTROL_NAME": "arCatalogFilter_188_838008019",
                                "CONTROL_NAME_ALT": "arCatalogFilter_188",
                                "HTML_VALUE_ALT": 838008019,
                                "HTML_VALUE": "Y",
                                "VALUE": "topaz",
                                "SORT": 0,
                                "UPPER": "TOPAZ",
                                "FLAG": null,
                                "URL_ID": "topaz"
                            },
                            "bez_vstavki": {
                                "CONTROL_ID": "arCatalogFilter_188_3534211685",
                                "CONTROL_NAME": "arCatalogFilter_188_3534211685",
                                "CONTROL_NAME_ALT": "arCatalogFilter_188",
                                "HTML_VALUE_ALT": 3534211685,
                                "HTML_VALUE": "Y",
                                "VALUE": "bez_vstavki",
                                "SORT": 1,
                                "UPPER": "BEZ_VSTAVKI",
                                "FLAG": null,
                                "URL_ID": "bez_vstavki"
                            }
                        }
                    },
                    "191": {
                        "ID": "191",
                        "IBLOCK_ID": "24",
                        "CODE": "ST_VSTAVKA_COLOR",
                        "~NAME": "Цвет вставки",
                        "NAME": "Цвет вставки",
                        "PROPERTY_TYPE": "S",
                        "USER_TYPE": "directory",
                        "USER_TYPE_SETTINGS": {
                            "size": 1,
                            "width": 0,
                            "group": "N",
                            "multiple": "N",
                            "TABLE_NAME": "a_colors"
                        },
                        "DISPLAY_TYPE": "F",
                        "DISPLAY_EXPANDED": "N",
                        "FILTER_HINT": "",
                        "VALUES": {
                            "bezbarvniy": {
                                "CONTROL_ID": "arCatalogFilter_191_3499411208",
                                "CONTROL_NAME": "arCatalogFilter_191_3499411208",
                                "CONTROL_NAME_ALT": "arCatalogFilter_191",
                                "HTML_VALUE_ALT": 3499411208,
                                "HTML_VALUE": "Y",
                                "VALUE": "bezbarvniy",
                                "SORT": 0,
                                "UPPER": "BEZBARVNIY",
                                "FLAG": null,
                                "URL_ID": "bezbarvniy"
                            },
                            "biliy": {
                                "CONTROL_ID": "arCatalogFilter_191_3218423947",
                                "CONTROL_NAME": "arCatalogFilter_191_3218423947",
                                "CONTROL_NAME_ALT": "arCatalogFilter_191",
                                "HTML_VALUE_ALT": 3218423947,
                                "HTML_VALUE": "Y",
                                "VALUE": "biliy",
                                "SORT": 0,
                                "UPPER": "BILIY",
                                "FLAG": null,
                                "URL_ID": "biliy"
                            },
                            "chorniy": {
                                "CONTROL_ID": "arCatalogFilter_191_3329127398",
                                "CONTROL_NAME": "arCatalogFilter_191_3329127398",
                                "CONTROL_NAME_ALT": "arCatalogFilter_191",
                                "HTML_VALUE_ALT": 3329127398,
                                "HTML_VALUE": "Y",
                                "VALUE": "chorniy",
                                "SORT": 0,
                                "UPPER": "CHORNIY",
                                "FLAG": null,
                                "URL_ID": "chorniy"
                            },
                            "london_blyu_topaz": {
                                "CONTROL_ID": "arCatalogFilter_191_3374416450",
                                "CONTROL_NAME": "arCatalogFilter_191_3374416450",
                                "CONTROL_NAME_ALT": "arCatalogFilter_191",
                                "HTML_VALUE_ALT": 3374416450,
                                "HTML_VALUE": "Y",
                                "VALUE": "london_blyu_topaz",
                                "SORT": 0,
                                "UPPER": "LONDON_BLYU_TOPAZ",
                                "FLAG": null,
                                "URL_ID": "london_blyu_topaz"
                            }
                        }
                    },
                    "192": {
                        "ID": "192",
                        "IBLOCK_ID": "24",
                        "CODE": "COLLECTION",
                        "~NAME": "Коллекция",
                        "NAME": "Коллекция",
                        "PROPERTY_TYPE": "E",
                        "USER_TYPE": null,
                        "USER_TYPE_SETTINGS": null,
                        "DISPLAY_TYPE": "F",
                        "DISPLAY_EXPANDED": "N",
                        "FILTER_HINT": "",
                        "VALUES": {
                            "50714": {
                                "CONTROL_ID": "arCatalogFilter_192_2567256152",
                                "CONTROL_NAME": "arCatalogFilter_192_2567256152",
                                "CONTROL_NAME_ALT": "arCatalogFilter_192",
                                "HTML_VALUE_ALT": 2567256152,
                                "HTML_VALUE": "Y",
                                "VALUE": "Без коллекции",
                                "SORT": 500,
                                "UPPER": "БЕЗ КОЛЛЕКЦИИ",
                                "FLAG": null,
                                "URL_ID": "bez-kollektsii"
                            },
                            "52994": {
                                "CONTROL_ID": "arCatalogFilter_192_4048246737",
                                "CONTROL_NAME": "arCatalogFilter_192_4048246737",
                                "CONTROL_NAME_ALT": "arCatalogFilter_192",
                                "HTML_VALUE_ALT": 4048246737,
                                "HTML_VALUE": "Y",
                                "VALUE": "Eclipse",
                                "SORT": 500,
                                "UPPER": "ECLIPSE",
                                "FLAG": null,
                                "URL_ID": "eclipse"
                            }
                        }
                    },
                    "193": {
                        "ID": "193",
                        "IBLOCK_ID": "24",
                        "CODE": "VID",
                        "~NAME": "Тип изделия",
                        "NAME": "Тип изделия",
                        "PROPERTY_TYPE": "S",
                        "USER_TYPE": "directory",
                        "USER_TYPE_SETTINGS": {
                            "size": 1,
                            "width": 0,
                            "group": "N",
                            "multiple": "N",
                            "TABLE_NAME": "a_types"
                        },
                        "DISPLAY_TYPE": "F",
                        "DISPLAY_EXPANDED": "Y",
                        "FILTER_HINT": "",
                        "VALUES": {
                            "braslet": {
                                "CONTROL_ID": "arCatalogFilter_193_341337972",
                                "CONTROL_NAME": "arCatalogFilter_193_341337972",
                                "CONTROL_NAME_ALT": "arCatalogFilter_193",
                                "HTML_VALUE_ALT": 341337972,
                                "HTML_VALUE": "Y",
                                "VALUE": "braslet",
                                "SORT": 0,
                                "UPPER": "BRASLET",
                                "FLAG": null,
                                "URL_ID": "braslet"
                            },
                            "lantsyuzhok": {
                                "CONTROL_ID": "arCatalogFilter_193_151778265",
                                "CONTROL_NAME": "arCatalogFilter_193_151778265",
                                "CONTROL_NAME_ALT": "arCatalogFilter_193",
                                "HTML_VALUE_ALT": 151778265,
                                "HTML_VALUE": "Y",
                                "VALUE": "lantsyuzhok",
                                "SORT": 0,
                                "UPPER": "LANTSYUZHOK",
                                "FLAG": null,
                                "URL_ID": "lantsyuzhok"
                            },
                            "persten": {
                                "CONTROL_ID": "arCatalogFilter_193_853360208",
                                "CONTROL_NAME": "arCatalogFilter_193_853360208",
                                "CONTROL_NAME_ALT": "arCatalogFilter_193",
                                "HTML_VALUE_ALT": 853360208,
                                "HTML_VALUE": "Y",
                                "VALUE": "persten",
                                "SORT": 0,
                                "UPPER": "PERSTEN",
                                "FLAG": null,
                                "URL_ID": "persten"
                            },
                            "serezhki": {
                                "CONTROL_ID": "arCatalogFilter_193_2037043039",
                                "CONTROL_NAME": "arCatalogFilter_193_2037043039",
                                "CONTROL_NAME_ALT": "arCatalogFilter_193",
                                "HTML_VALUE_ALT": 2037043039,
                                "HTML_VALUE": "Y",
                                "VALUE": "serezhki",
                                "SORT": 0,
                                "UPPER": "SEREZHKI",
                                "FLAG": null,
                                "URL_ID": "serezhki"
                            }
                        }
                    },
                    "214": {
                        "ID": "214",
                        "IBLOCK_ID": "24",
                        "CODE": "VID_IZDELIYA",
                        "~NAME": "Вид",
                        "NAME": "Вид",
                        "PROPERTY_TYPE": "L",
                        "USER_TYPE": null,
                        "USER_TYPE_SETTINGS": null,
                        "DISPLAY_TYPE": "F",
                        "DISPLAY_EXPANDED": "N",
                        "FILTER_HINT": "",
                        "VALUES": []
                    },
                    "215": {
                        "ID": "215",
                        "IBLOCK_ID": "24",
                        "CODE": "Type_vstavok",
                        "~NAME": "Тип вставки",
                        "NAME": "Тип вставки",
                        "PROPERTY_TYPE": "L",
                        "USER_TYPE": null,
                        "USER_TYPE_SETTINGS": null,
                        "DISPLAY_TYPE": "F",
                        "DISPLAY_EXPANDED": "N",
                        "FILTER_HINT": "",
                        "VALUES": []
                    },
                    "Розничная": {
                        "ID": "4",
                        "CODE": "Розничная",
                        "~NAME": "Розничная",
                        "NAME": "Розничная",
                        "PRICE": true,
                        "VALUES": {
                            "MIN": {
                                "CONTROL_ID": "arCatalogFilter_P4_MIN",
                                "CONTROL_NAME": "arCatalogFilter_P4_MIN",
                                "VALUE": "3213.00",
                                "CURRENCY": "UAH"
                            },
                            "MAX": {
                                "CONTROL_ID": "arCatalogFilter_P4_MAX",
                                "CONTROL_NAME": "arCatalogFilter_P4_MAX",
                                "VALUE": "3213.00",
                                "CURRENCY": "UAH"
                            }
                        },
                        "ENCODED_ID": "a87ff679a2f3e71d9181a67b7542122c",
                        "CURRENCIES": {"UAH": "Гривна"}
                    }
                },
                "actions": {"resetFilter": {"href": "/catalog/test/filter/clear/apply/", "text": "Сбросить фильтр"}}
            })
        },
        showShortFilter: {
            type: Boolean
        },
        options: {
            type: Object,
            default: () => ({
                showAsideMenu: false
            })
        }
    },
}
</script>

<style lang="scss" scoped>
.catalog-filter {
    position: relative;
    &__color {
        padding: 14px 14px 69px;
        background-color: #ffffff;
        @include point-lg {
            padding: 32px;
        }
    }

    &__button {
        margin-top: 10px;
        &:first-child{
            margin-right: 15px;
            @include point-lg{
                margin-right: 0;
            }
        }
    }

    &__buttons_wrapper {
        display: flex;
        justify-content: center;
        gap: 10px;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: #fff;
        padding: 0 24px 10px;
        border-top: 1px solid #DFDFDF;
        @include point-lg{
            position: sticky;
            left: -14px;
            right: -14px;
            padding: 0 0 10px;
        }
    }

    &__line {
        margin: 24px 0;
        border-top: none;
        border-bottom-color: #DFDFDF;
    }

    &__title {
        font-weight: 500;
        font-size: rem(12);
        letter-spacing: 0.08em;
        text-transform: uppercase;
        color: #191918;
        margin-bottom: 16px;
        @include point-md {
            font-size: rem(14);
        }
    }
}
.filter-range {
    display: flex;

    &__input {
        width: 100%;
        max-width: 73px;
        height: 32px;
        flex-grow: 2;
        padding: 0 7px;
        border: 1px solid #DFDFDF;
        margin-right: 8px;
        font-size: rem(16);
        color: #757575;
        @include point-md {
            max-width: 96px;
        }
        @include point-lg {
            max-width: 70px;
        }
        @include point-xl {
            max-width: 96px;
        }
    }

    &__button {
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 500;
        font-size: rem(14);
        letter-spacing: 0.08em;
        text-transform: uppercase;
        color: #FFFFFF;
        background: var(--border-colour-primary);
        flex-grow: 1;

        &:hover {
            cursor: pointer;
        }
    }
}
.filter-mobile-title{
    display: flex;
    align-items: center;
    height: 56px;
    padding: 0 24px;
    margin-top: -10px;
    box-shadow: 0px 4px 5px rgba(47, 76, 120, 0.1);
    position: relative;
    z-index: 1;
    width: calc(100% + 20px);
    transform: translateX(-10px);
    font-weight: 500;
    font-size: rem(14);
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--text-colour-primary);
    margin-bottom: 10px;
    @include point-md{
        font-size: rem(16);
        width: calc(100% + 40px);
        transform: translateX(-20px);
        padding: 0 34px;
        margin-top: -20px;
    }
}
.filter-links{
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    color: var(--text-colour-primar);
    text-transform: uppercase;
    border-bottom: 1px solid #DFDFDF;
    padding-bottom: 20px;
    font-size: 0.75rem;
    @include point-md{
        font-size: 0.875rem;
    }

    &__items {
        padding-left: 32px;
    }

    &__item {
        &:not(:last-child) {
            margin-bottom: 10px;
        }

        &_active {
            color: var(--discount-color);
        }
    }

    &__title {
        font-weight: 500;
        letter-spacing: 0.08em;
        margin-bottom: 21px;
    }
}
</style>